import { useImportCsv } from 'commons/hooks/useImportCsv';
import productsServices from 'domains/Catalog/Products/productsServices';

export function useImportProducts() {
  return useImportCsv(
    'productsCsvImport',
    productsServices.importFile,
    productsServices.fetchImportColumns,
  );
}
